import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { fontWeight } from '@/theme';
import ImgLogo from '@/assets/images/shuffle-logo-dark.svg';
import ImgWallet from '@/assets/images/wallet.svg';

export default function AuthPageBanner() {
  return (
    <Box>
      <Box mb={2.5} pt={6}>
        <ImgLogo />
      </Box>
      <Stack direction="row" justifyContent="space-between" mb={5}>
        <Typography variant="h4" fontWeight={fontWeight.Bold}>
          쉽고 안전한 디지털
          <br />
          자산 통합 지갑
        </Typography>
        <ImgWallet />
        {/*  */}
      </Stack>
    </Box>
  );
}
